const localStorageKey = '__loginTimer';

export const getInitialTime = (email, target_mdn) => {
  if (!email && !target_mdn) {
    return null;
  }

  const key = email ? email.trim() : target_mdn.trim();
  const localStoreValue = window.localStorage.getItem(localStorageKey);
  const previousTimers = localStoreValue ? JSON.parse(localStoreValue) : null;
  const previousTimer = previousTimers ? previousTimers[key] : null;
  if (previousTimer) {
    const previousTime = new Date(previousTimer);
    const now = new Date();
    const timeDiff = now - previousTime;
    const tenMinsInMiliseconds = 600000;
    if (timeDiff < tenMinsInMiliseconds) {
      const diffInSecons = parseInt(
        (tenMinsInMiliseconds - timeDiff) / 1000,
        10,
      );
      return diffInSecons;
    }
  }
};

export const setInitialTime = (email, target_mdn) => {
  if (!email && !target_mdn) {
    return null;
  }

  const key = email ? email.trim() : target_mdn.trim();

  const localStoreValue = window.localStorage.getItem(localStorageKey);
  const previousTimers = localStoreValue ? JSON.parse(localStoreValue) : {};

  const now = new Date();
  const newTimers = { ...previousTimers, [key]: now.toISOString() };
  const stringifiedNewTimers = JSON.stringify(newTimers);

  window.localStorage.setItem(localStorageKey, stringifiedNewTimers);
};